import {checkIfUserHasRole} from "@/core/utils/helpers/checkIfUserHasRole";
import moment from "moment";
import {regionRelativeUrl, isUnitedKingdomRegion} from "@/core/utils/helpers/regions/regionUrlHelper";
import {getUserLocationForSearchUnitedKingdom} from "@/core/utils/helpers/search/ukSearchLocationHelper";

function isRegularUser(user) {
    return _.get(user, 'profile_type', 1) === 0;
}

function getUserAge(user, prefix = '') {
    if (this.isRegularUser(user)) {
        const age = _.get(user, 'features.age', '');
        if (age) {
            return prefix + age;
        }
    }
    return '';
}

function getUserLocationForSearch(user) {
    if (isUnitedKingdomRegion()) {
        return getUserLocationForSearchUnitedKingdom(user);
    }

    const suburb = _.get(user, 'suburb', '');
    const city = _.get(user, 'city', '');

    if (suburb) {
        if (city) {
            return suburb + ', ' + city;
        }

        return suburb;
    }

    return city;
}

/**
 * @param {object} user
 * @returns {boolean}
 */
function isGoldUser(user) {
    return _.get(user, 'premium', false);
}

/**
 * @param {object} user
 * @returns {boolean}
 */
function isSilverUser(user) {
    return _.get(user, 'plus_status', false);
}

/**
 * @param {object} user
 * @returns {boolean}
 */
function isNewUser(user) {
    return _.get(user, 'new', false);
}

function isUserLatLongSetAndValid(user) {
    const lat = _.get(user, 'lat', -999);
    const lon = _.get(user, 'lon', -999);
    return (
        lat != null
        && lon != null
        && lat >= -90
        && lat <= 90
        && lon >= -180
        && lon <= 180
    );
}

function updateCurrentUser(data) {
    const user = _.cloneDeep(this.currentUser);
    this.store.commit('setCurrentUser', _.merge(user, data));
}

function isValidVipDate(user) {
    const now = moment();
    const vipValidTill = moment(_.get(user, 'vip_valid_till', null));
    return vipValidTill.isSameOrAfter(now);
}

function hasRole(user, roleId) {
    return checkIfUserHasRole(roleId, user);
}

function formatLocation(user) {
    const addressParts = [
        _.get(user, 'street'),
        _.get(user, 'suburb'),
        _.get(user, 'city'),
        _.get(user, 'postcode'),
    ];

    return addressParts
        .filter(item => item)
        .join(', ');
}

/**
 *
 * @param path {string}
 * @returns {string}
 */
function originUrlWithPath(path) {
    if (typeof window !== 'undefined') {
        return `${window.location.origin}${path}`;
    }

    return '/';
}

function userLocationCoordinates(user) {
    if (!this.isUserLatLongSetAndValid(user)) {
        return undefined;
    }

    return {
        lat: _.get(user, 'lat', -999),
        lon: _.get(user, 'lon', -999),
    }
}

function isUserEscort(user) {
    return checkIfUserHasRole(constants.user_role.OFFERING_SERVICES, user);
}

function isUserVenue(user) {
    return checkIfUserHasRole(constants.user_role.VENUE, user);
}

function isUserEscortOrVenue(user) {
    return this.isUserEscort(user) || this.isUserVenue(user);
}

function isRequestContentButtonVisible() {
    if (_.get(this, 'user.is_ai', false)) {
        return false;
    }

    const lastOnline = _.get(this, 'user.last_login');
    if (!lastOnline || !this.moment().isBefore(this.moment(lastOnline).add(7, 'days'))) {
        return false;
    }

    return !this.isLoggedIn || this.isPunter;
}

function getUrl(websiteUrl) {
    let finalUrl = websiteUrl;

    const pattern = /^((http|https):\/\/)/;

    if (!pattern.test(finalUrl)) {
        finalUrl = "http://" + finalUrl;
    }

    finalUrl += '?utm_source=erobella.com&utm_medium=referral';

    return finalUrl;
}

export default {
    data() {
        return {
            store: $store,
            moment: moment,
        }
    },
    computed: {
        ...mapState(['translate', 'currentUser']),
        isEscort() {
            return checkIfUserHasRole(constants.user_role.OFFERING_SERVICES, this.currentUser);
        },
        isPunter() {
            return checkIfUserHasRole(constants.user_role.SEEKING_SERVICES, this.currentUser);
        },
        isManager() {
            return checkIfUserHasRole(constants.user_role.MANAGER, this.currentUser);
        },
        isVenue() {
            return checkIfUserHasRole(constants.user_role.VENUE, this.currentUser);
        },
        isChatter() {
            return checkIfUserHasRole(constants.user_role.CHATTER, this.currentUser);
        },
        isGodAdmin() {
            return checkIfUserHasRole(constants.user_role.GOD_ADMIN, this.currentUser);
        },
        isSuperGodAdmin() {
            return checkIfUserHasRole(constants.user_role.SUPER_GOD_ADMIN, this.currentUser);
        },
        hasManager() {
            return !!_.get(this, 'currentUser.manager_id', false);
        },
        hasQuarantinedManager() {
            return typeof context !== "undefined"
                && _.get(this, 'currentUser.manager_id', false)
                && _.get(context, 'managerData.isQuarantined');
        },
        isLoggedIn() {
            return !!this.currentUser;
        },
        isAgeVerified() {
            return _.get(this, 'currentUser.user_age_verification.is_successful', false);
        },
        isQuarantinedUser() {
            return _.get(this, 'currentUser.isQuarantined');
        },
        is24HQuarantinedUser() {
            return this.currentUser.republish_at && !this.currentUser.first_listed_date && !_.get(this.currentUser, 'premium', false)
        },
        isVipPunter() {
            return _.get(this, 'currentUser.is_vip', false);
        },
        isVipPunterVisitor() {
            return this.isValidVipDate(this.user)
        },
        fullProfileUrl() {
            if (typeof window !== 'undefined' && _.get(this, 'currentUser.profile_path', false)) {
                return window.location.origin + regionRelativeUrl(this.currentUser.profile_path)
            }
            return false;
        },
        creditsString() {
            let credits = _.get(this, 'currentUser.credits', false);

            if (typeof isManagerLoggedIn !== 'undefined' && isManagerLoggedIn) {
                credits = context.managerData.credits;
            }

            if (!credits) {
                return '0';
            }
            return Number(credits).toFixed();
        },
        topLevelServiceProvider() {
            return (this.isEscort || this.isVenue || this.isManager) && !this.hasManager;
        },
        isUserAdmin() {
            if (!this.currentUser || !this.currentUser.roles) {
                return false;
            }

            const adminRoles = [
                constants.user_role.SUPER_ADMIN,
                constants.user_role.ADMIN,
                constants.user_role.CORE_ADMIN,
                constants.user_role.SUPER_GOD_ADMIN,
                constants.user_role.SUPPORT,
            ];
            const userRoles = _.get(this.currentUser, 'roles', []).map(r => r.id)
            return _.intersection(adminRoles, userRoles).length > 0;
        },
        isAdminImpersonating() {
            return (typeof isAdminLoggedIn !== "undefined" && isAdminLoggedIn)
        },
        isRequestContentButtonVisible,
    },
    methods: {
        isRegularUser,
        getUserAge,
        getUserLocationForSearch,
        isGoldUser,
        isSilverUser,
        isNewUser,
        isUserLatLongSetAndValid,
        updateCurrentUser,
        isValidVipDate,
        hasRole,
        formatLocation,
        originUrlWithPath,
        userLocationCoordinates,
        isUserEscort,
        isUserVenue,
        isUserEscortOrVenue,
        getUrl,
    }
}
